const STORAGE_KEY = 'ipe-system-announcement-popup-dismissed';

function readStore() {
  if (typeof window === 'undefined') return {};
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

function writeStore(store) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch {
    // ignore quota errors
  }
}

function scopeKey(userId) {
  return userId != null && userId !== '' ? String(userId) : '_anonymous';
}

export function isSystemAnnouncementPopupDismissed(userId, announcementId) {
  if (!announcementId) return false;
  const scoped = readStore()[scopeKey(userId)];
  if (!scoped || typeof scoped !== 'object') return false;
  return Boolean(scoped[String(announcementId)]);
}

export function dismissSystemAnnouncementPopup(userId, announcementId) {
  if (!announcementId) return;
  const store = readStore();
  const key = scopeKey(userId);
  store[key] = {
    ...(store[key] && typeof store[key] === 'object' ? store[key] : {}),
    [String(announcementId)]: Date.now(),
  };
  writeStore(store);
}
